module.exports = __webpack_public_path__ + "images/category_lp/common/store_images/smart_buyer_5aa1a6f52fba943db1f28011afaa2440.png";